module.exports = {"231281001":"铁西街道","231281002":"新兴街道","231281003":"安虹街道","231281100":"安达镇","231281101":"任民镇","231281103":"万宝山镇","231281104":"昌德镇","231281105":"升平镇","231281106":"羊草镇","231281107":"老虎岗镇","231281108":"中本镇","231281109":"太平庄镇","231281110":"吉兴岗镇","231281202":"火石山乡","231281204":"卧里屯乡","231281205":"青肯泡乡","231281209":"先源乡","231281500":"安达畜牧场","231281581":"原种场","231281583":"红旗泡水库管理所","231281584":"东湖水库管理站"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231281.json
// module id = 739
// module chunks = 0